import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {TreeNode} from 'primeng/primeng';
import { AdminService } from '../../../../../services/admin.service';
import { SortTableService } from '../../../../../services/sort-table.service';
import { UserService } from '../../../../../services/user.service';
import {LearningService} from '../../service/learning.service';

@Component({
  selector: 'app-learning',
  templateUrl: './learning.component.html',
  styleUrls: ['./learning.component.css']
})
export class LearningComponent implements OnInit, OnDestroy {

  selection = [];
  data: TreeNode[];

  nodesCopy: any[] = [];
  nodesFiltered: any[] = [];
  nodesOriginal: any[] = [];
  nodesTemp: TreeNode[] = [];
  nodesFilteredWithParents: TreeNode[] = [];

  nodePath: number[] = [];
  nodePathMap: Map<number[], string> = new Map();

  isFiltered: false;
  isLoaded = false;
  myList = [];
  myLists = [];
  visible = false;
  totalVeight;
  totalWeigth;
  checkAdmin = false;
  userInfo;
  myListSort = [];
  groupName;

  usersfix = [];

  sortDetails = {
    myList: {
      field: 'title',
      sortType: 'ascending'
    },
    myLists: {
      field: 'title',
      sortType: 'ascending'
    }
  };

  constructor(private adminService: AdminService, public sortTableService: SortTableService,public learningService: LearningService, private route: ActivatedRoute, public userService: UserService) {
  }

  ngOnInit() {
    if(this.route.snapshot.params['department']){
        this.getListStarMap(this.route.snapshot.params['id']);
    } else {
      if(this.route.snapshot.params['id'] && this.userService.getLocal().id !== this.route.snapshot.params['id']) {
        this.getListOfSpecs(this.route.snapshot.params['id']);
        this.getUserById(this.route.snapshot.params['id'])
        this.checkAdmin = true;
      } else {
        this.getListOfSpecs(this.userService.getLocal().id);
        this.checkAdmin = false;
      }
    }
    this.learningService.clearNodeSelection();
  }

  getListStarMap(id) {
		this.adminService.getAllGroupsForListMap(id).subscribe(
			(response: any) => {
        this.totalVeight = response.body.learningSum.sumLevel;
        this.totalWeigth = response.body.learningSum.sumWeight;        
        let arr = response.body.specialization
        arr.forEach(groupNode => {
          if(groupNode.date) {
                groupNode.date = groupNode.date.split('T')[0];
          } 
        });
        this.getList();
        this.myLists = arr;
			},
		);
	}

  ngOnDestroy() {
    this.learningService.testPassed = false;
    this.learningService.testFailed = false;
  }

  fixUSers(i) {
    this.usersfix = [];
    this.usersfix.push(...this.myLists[i].users);
  }

  getUserById(id) {
    this.userService.getUserFromAPI(id).subscribe(
      (response: any) => {
        let user = response.body;
        this.userInfo = user.fullName
      })
  }

  close() {
    this.usersfix = [];
  }

  getList() {
		this.adminService.getGroupByID(this.route.snapshot.params['id']).subscribe(
			(response: any) => {
        this.groupName = response.body.name;
			},
			() => 
      {
			},
		);
	}

  getListOfSpecs(id) {
    this.learningService.getLearningSpecs(id).subscribe(
      (response: any) => {
        if (response.status === 204) {
          this.learningService.noSpecializations = true;
          this.isLoaded = true;
        }
        if (response.status === 200) {
          this.totalVeight = response.body.sumLevel;
          this.totalWeigth = response.body.sumWeight;        
          let arr = response.body.treeNodeForUsers
          arr.forEach(groupNode => {
            if(groupNode.children) {
              groupNode.children.forEach(groupNode => {
                if(groupNode.data.date) {
                  groupNode.data.date = groupNode.data.date.split('T')[0];
                }
              });
            }
          });
          const filtredNodes: TreeNode[] = this.hideEmpty(response.body.treeNodeForUsers);
          this.learningService.setNodes(filtredNodes);
          this.nodesOriginal = filtredNodes;
          this.nodesCopy = this.nodesOriginal;
          this.learningService.noSpecializations = this.nodesCopy.length < 1;
          this.learningService.getSpecializationsError = false;
          this.isLoaded = true;
          this.filterByLevel()
        }
      },
      (error) => {
        if (error.status === 502) {
          this.learningService.getSpecializationsError = true;
          this.isLoaded = true;
        }
        if (error.status === 500) {
          this.learningService.getSpecializationsError = true;
          this.isLoaded = true;
        }
      }
    );
  }

  sortedTable(tableName, field) {
    this.sortDetails[tableName].field = field;
    return this.sortDetails[tableName].sortType === 'descending' ? 'ascending' : 'descending';
  }

  sortList = (tableName, list, field, sortType= null) => {
    if (sortType) {
      this.sortDetails[tableName].sortType = this.sortedTable(tableName, field);
    }
    switch (this.sortDetails[tableName].field) {
      case ('level'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => (b.data.level - a.data.level)):
          list.sort((a, b) => (a.data.level - b.data.level));
        break;
      case ('date'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          this.myList.sort((a, b) => b.data.date.localeCompare(a.data.date)):
          this.myList.sort((a, b) => a.data.date.localeCompare(b.data.date));
        break;
      case ('department'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => b.data.prefix.localeCompare(a.data.prefix)):
          list.sort((a, b) => a.data.prefix.localeCompare(b.data.prefix));
        break;
    }
  }

  sortLists = (tableName, list, field, sortType= null) => {
    if (sortType) {
      this.sortDetails[tableName].sortType = this.sortedTable(tableName, field);
    }
    switch (this.sortDetails[tableName].field) {
      case ('level'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => (b.levels - a.levels)):
          list.sort((a, b) => (a.levels - b.levels));
        break;
      case ('date'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          this.myLists.sort((a, b) => b.date.localeCompare(a.date)):
          this.myLists.sort((a, b) => a.date.localeCompare(b.date));
        break;
      case ('department'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => b.prefix.localeCompare(a.prefix)):
          list.sort((a, b) => a.prefix.localeCompare(b.prefix));
        break;
    }
  }

  nodeSelect(event) {
    this.learningService.nodeLevel = event.node.data.level;
    this.learningService.nodeId = event.node.data.id;
    this.learningService.nodeName = event.node.data.name;
    this.learningService.nodeType = event.node.data.type;
  }

  nodeUnselect() {
    this.selection = [];
    this.learningService.clearNodeSelection();
  }

  check() {
    if(this.visible) {
      this.visible = false;
    } else {
      this.visible = true;
    }
  }

  filterByLevel() {
    this.check();
    this.isFiltered = <false>!this.isFiltered;
    this.nodesFiltered = [];
    if (this.isFiltered) {

      this.nodesFiltered = [];
      this.nodesTemp = [];
      this.nodesFilteredWithParents = [];

      if (this.nodesOriginal.length > 0) {
        this.myList = [];
        this.nodesOriginal.forEach(groupNode => {
          const t = [];
          this.nodePath = t;
          this.myList.push(...groupNode.children);
          this.myList.forEach((groupNode, index, object) => {
            if(Number(groupNode.data.level) < 1) {
              object.splice(index, 1);
            }
          });
          this.nodePath.push(this.nodesOriginal.indexOf(groupNode));
          this.startSearch(groupNode);
        });
      }
      

      this.nodesCopy = this.nodesFiltered;

    } else {
      this.nodesCopy = this.nodesOriginal;
    }
  }

  searchNode(groupNode) {
    if (groupNode.children) {
      this.startSearch(groupNode);
    } else {
      if (groupNode.data.level) {
        const tmpPath = this.nodePath;
        this.nodePathMap.set(tmpPath, groupNode.data.name);
        this.nodesFiltered.push(groupNode);
      }
    }
  }

  startSearch(grpNode) {
    if (grpNode.children) {
      grpNode.children.forEach(childNode => {
        this.nodePath.push(grpNode.children.indexOf(childNode));
        this.searchNode(childNode);
      });

    } else {
      if (grpNode.data.level) {
        const tmpPath = this.nodePath;
        this.nodePathMap.set(tmpPath, grpNode.data.name);
        this.nodesFiltered.push(grpNode);
      }
    }
  }

  hideEmpty(nodesRequest: TreeNode[]) {
    const resultNodes: TreeNode[] = [];

    // Check each Node
    for (let i = 0; i < nodesRequest.length; i++) {
      // Check first level
      if (nodesRequest[i].children && nodesRequest[i].children.length > 0) {

        const childArr: TreeNode[] = this.hideEmpty(nodesRequest[i].children);
        if (childArr.length > 0) {
          nodesRequest[i].children = childArr;
          resultNodes.push(nodesRequest[i]);
        }

      } else {
        if (nodesRequest[i].data.type === 'Specialization') {
          resultNodes.push(nodesRequest[i]);
        }
      }
    }

    return resultNodes;
  }


}





// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/learning/components/learning/learning.component.ts